var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_ionic-ios-arrow-down","data-name":"Icon ionic-ios-arrow-down","d":"M8,6.39,14.053.336a1.139,1.139,0,0,1,1.615,0,1.153,1.153,0,0,1,0,1.62L8.813,8.815a1.141,1.141,0,0,1-1.577.033L.333,1.96A1.144,1.144,0,0,1,1.948.341Z","fill":"#c5c5c5","opacity":"0.6"}));
}

ArrowDown.defaultProps = {"width":"16","height":"9.148","viewBox":"0 0 16 9.148"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
